import { useNavigate } from 'react-router-dom';
import TestHistoryTab from './TestHistoryTab';
import Button from '../components/Button';
import { useRole } from '../hooks/useRole';
import { exportApi } from '../lib/api';
import { Download } from 'lucide-react';

export default function TestHistory() {
  const navigate = useNavigate();
  const { isEditor } = useRole();

  return (
    <div className="space-y-6">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <div>
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3">
            Test History
          </h1>
          <p className="text-base md:text-lg text-gray-600">
            View all test records across all battery packs
          </p>
        </div>
        <div className="flex flex-col sm:flex-row gap-3">
          <Button
            variant="secondary"
            onClick={async () => {
              try {
                await exportApi.download('tests');
              } catch (error) {
                alert('Failed to export tests');
              }
            }}
            className="flex items-center justify-center gap-2"
          >
            <Download className="w-4 h-4" />
            Export
          </Button>
          {isEditor && (
            <Button
              variant="primary"
              onClick={() => navigate('/tests/new')}
              className="flex items-center justify-center gap-2"
            >
              + Add New Test
            </Button>
          )}
        </div>
      </div>
      <TestHistoryTab />
    </div>
  );
}


